<template>
  <section class="padding-bottom-needed templates">
    <div>
      <locations-list @location-change="(companyUuid) => handleLocationChange(companyUuid)" />
    </div>
    <div v-if="$store.state.locationsList.length">
      <br>
      <div class="columns overflow-x-scroll">
        <div class="column is-12 is-paddingless has-text-centered">
          <div class="field has-addons flex space-x-1">
            <div
              v-for="item in templates"
              :key="item.uuid"
              class="control"
            >
              <button
                class="button"
                :class="show[item.uuid] ? 'primary' : 'secondary'"
                @click="showDocument(item.uuid)"
              >
                Preview
                {{ item.template_name }}
              </button>
            </div>
            <!--                        <div class="control"><button class="button primary" :class="[show['sale'] ? '' : 'is-outlined']" @click="showDocument('sale')">Preview Lien to Sale Notice</button></div>-->
          </div>
        </div>
      </div>
      <div
        v-for="item in templates"
        v-show="show[item.uuid]"
        :key="item.uuid"
        class="columns template_display overflow-auto mt-0"
      >
        <div class="column is-12 is-paddingless">
          <div
            class="template-page"
            v-html="item.template"
          />
        </div>
      </div>
      <!--        <div class="actionbar-bottom has-background-white" id="actionbar">-->
      <!--            <div class="container is-fullhd">-->
      <!--                <div class="columns">-->
      <!--                    <div class="column is-12">-->
      <!--                        <p class="has-text-right">-->
      <!--                            <button class="button primary" id="saveTemplate" @click="saveTemplate">-->
      <!--                                <span class="icon"><i class="fas fa-save" aria-hidden="true"></i></span>-->
      <!--                                <span>Save Template</span>-->
      <!--                            </button>-->
      <!--                        </p>-->
      <!--                    </div>-->
      <!--                </div>-->
      <!--            </div>-->
      <!--        </div>-->

      <!-- Modal if user leave without saving -->
      <div
        class="modal"
        :class="{'is-active' : show_modal_leaving}"
      >
        <div
          class="modal-background"
          @click="show_modal_leaving = false"
        />
        <div class="modal-content">
          <div class="box">
            <h6>Save template modification?</h6>
            <p>There are some unsaved changes. Would you like to save them before leaving the page?</p>
            <p
              class="control has-text-right"
              style="margin-top: 2rem"
            >
              <a
                href="#"
                class="button is-white"
                @click="hideLeavingModal()"
              >Discard</a>
              <a
                href="#"
                class="button primary is-outlined"
                @click="saveAndRedirect"
              >Save</a>
            </p>
          </div>
        </div>
        <button
          class="modal-close is-large"
          aria-label="close"
          @click="show_modal_leaving = false"
        />
      </div>
    </div>
    <div v-else>
      <div class="no-data card">
        <header class="card-header">
          <p>No templates linked to locations</p>
        </header>
      </div>
    </div>
  </section>
</template>
<script>
import LocationsList from '../location/LocationsList.vue';
import TemplateService from '../../services/template.service';

const templateService = new TemplateService();

export default {
  name: 'TemplateCustomize',
  components: {
    LocationsList
  },
  beforeRouteLeave(to, from, next) {
    if (this.unsaved_change) {
      this.show_modal_leaving = true;
      this.redirection_to = to;
      next(false);
    } else {
      next();
    }
  },
  data() {
    return {
      templates: [{
        name: '',
        uuid: 'ududu',
        email_subject: '',
        content_notice: '',
        content_sale: '',
        content_sms: '',
        content_ad: '',
        content_opposition_form: '',
        is_legal_state_template: false,
        is_company_template: false,
        template_name: '',
        template: ''
      }],
      company_logo: this.$store.state.company.base64_logo ? this.$store.state.company.base64_logo : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
      filename: 'Search on your computer',
      is_intro: false,
      show: {
        ududu: true
      },
      unsaved_change: false,
      show_modal_leaving: false,
      redirection_to: null
    };
  },
  computed: {
    locationsList() {
      return this.$store.state.locationsList;
    }
  },
  mounted() {
    this.$root.pageTitle = 'Customize your notification template';
    if (this.$route.name === 'intro-template') this.is_intro = true;
    if (this.is_intro) this.$root.showNavigation = false;

    if (document.querySelector('#actionbar')) {
      document.querySelector('.padding-bottom-needed').style.paddingBottom = `${document.querySelector('#actionbar').offsetHeight * 2}px`;
    }
  },
  methods: {
    showDocument(index) {
      const self = this;
      Object.keys(self.show).forEach((item) => {
        self.show[item] = false;
      });
      self.show[index] = true;
      this.$forceUpdate();
    },
    previewLogo(event) {
      const img = event.target.files[0];
      const self = this;
      const ext = img.name.match(/\.([^.]+)$/)[1];
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'bmp', 'gif', 'pjp', 'dib', 'jfif', 'pjpeg', 'webm'];

      if (!allowedExtensions.includes(ext)) {
        self.$root.$emit('showToast', {
          message: 'The file extension is not supported. Please choose image file.',
          options: {
            cssClass: 'is-danger',
            duration: 10000
          }
        });
      }
      const reader = new FileReader();
      self.filename = img.name;
      reader.addEventListener('load', () => {
        self.company_logo = reader.result;
        self.updateLogo();
      }, false);

      if (img) {
        reader.readAsDataURL(img);
      }
    },
    updateLogo() {
      const self = this;
      document.querySelectorAll('img.company_logo').forEach((elt) => {
        elt.src = self.company_logo;
      });
      this.unsaved_change = true;
      // this.saveTemplate(null);
    },
    saveTemplate(event, redirectionTo) {
      if (event) event.preventDefault();
      const self = this;
      const data = new FormData();
      data.append('base64_logo', this.company_logo);
      templateService.saveCompanyTemplate(this.$store.state.company.uuid, data)
        .then((response) => {
          const { status } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', { message: 'Template customization saved!', options: { cssClass: 'is-success', duration: 10000 } });
            self.$store.commit('updateCompany', response);

            self.unsaved_change = false;
            if (redirectionTo) self.$router.push({ name: self.redirection_to.name });

            if (self.is_intro) {
              self.$router.push({ name: 'dashboard' });
            }
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    saveAndRedirect() {
      this.saveTemplate(null, true);
    },
    hideLeavingModal() {
      this.unsaved_change = false;
      this.$router.push({ name: this.redirection_to.name });
    },
    getTemplates(companyUuid) {
      const self = this;
      templateService.getTemplates(companyUuid)
        .then((response) => {
          const { status, result } = response.data;
          if (status === 'success') {
            if (result.company_template !== null) {
              self.templates = result.company_template;
            } else {
              self.templates = result.state_template;
              let count = 0;
              // @todo recheck
              // eslint-disable-next-line guard-for-in, no-restricted-syntax
              for (const i in self.templates) {
                self.show[self.templates[i].uuid] = count === 0;
                // eslint-disable-next-line no-plusplus
                count++;
              }
              self.$forceUpdate();
            }
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(($er) => {
          console.log($er);
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        }).then(() => {
          self.updateLogo();
          self.unsaved_change = false;
        });
    },
    handleLocationChange(companyUuid) {
      this.getTemplates(companyUuid);
    }
  }
};
</script>
<style scoped lang="scss">
    .templates {
        .columns + .columns {
            margin-top: 3rem;
        }

        .card {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 15px 0;

            .card-content {
                height: 100%;
                padding-top: 3rem;
                padding-bottom: 2.5rem;
                line-height: 2rem;
            }

            .card-header-title {
                border-left-width: 4px;
                border-left-style: solid;
            }

            .card-footer {
                text-align: right;
                display: block;
                padding: 1rem;
            }
        }

        .file.is-right {
            justify-content: flex-start;
        }

        .file-cta, .file-name {
            border: 0;
            background-color: rgba(var(--primary-gray), 1);
            border-radius: 2px;
            height: auto;
        }

        .file-name {
            border-left: 4px solid rgba(var(--primary-yellow), 1) !important;
            color: rgba(var(--bordeaux), .5);
            padding: 1rem;
        }

        .has-addons .button.is-info.is-outlined {
            background-color: rgba(var(--primary-gray), 1) !important;
            color: rgba(var(--bordeaux), 1) !important;
            border-color: rgba(var(--primary-gray), 1) !important;
        }

        .has-addons .button.is-info {
            background-color: rgba(var(--blue), .3) !important;
            color: rgba(var(--primary-blue), 1) !important;
            border-color: transparent !important;
            border-bottom-color: rgba(var(--primary-blue), 1) !important;
            border-width: 2px;

            @apply
              bg-primary-500
        }

        .template_display {
          margin-top: 0 !important;
        }
    }
</style>
